import { render, staticRenderFns } from "./ExchangeBuildingMain.vue?vue&type=template&id=b7b86af0&"
import script from "./ExchangeBuildingMain.vue?vue&type=script&lang=js&"
export * from "./ExchangeBuildingMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports